import { Loader2 } from "lucide-react";

export const FullScreenLoader = ({ label, subtitle }: { label?: string; subtitle?: string }) => {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center gap-2 z-[9999] bg-background/95 backdrop-blur-sm">
      <Loader2 className="size-6 text-muted-foreground animate-spin" />
      {label && <p className="text-sm text-muted-foreground mx-5">{label}</p>}
      {subtitle && <p className="text-xs text-muted-foreground/80 max-w-md text-center mx-5">{subtitle}</p>}
    </div>
  );
};
